import { render } from "./MessageRow.vue?vue&type=template&id=4a580fe8&ts=true"
import script from "./MessageRow.vue?vue&type=script&lang=ts"
export * from "./MessageRow.vue?vue&type=script&lang=ts"

import "./MessageRow.vue?vue&type=style&index=0&id=4a580fe8&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__